import { httpV2 } from "../http";

const SeamService = {
  getSettings: () => httpV2.get("/seam/settings"),
  updateSettings: (data) => httpV2.put("/seam/settings", data),
  createPortal: () => httpV2.post("/seam/portal"),
  syncSpaces: () => httpV2.post("/seam/sync-spaces"),
  syncReservations: () => httpV2.post("/seam/sync-reservations"),
  getSyncRunStatus: (syncRunId) =>
    httpV2.get(`/seam/sync-reservations/${syncRunId}/status`),
  getAccessCodes: (reservationId) =>
    httpV2.get(`/seam/access-codes/${reservationId}`),
  getMonitoringActivity: (params) =>
    httpV2.get("/seam/monitoring/activity", { params }),
  getMonitoringDevices: (params) =>
    httpV2.get("/seam/monitoring/devices", { params }),
};

export default SeamService;
